module.exports = __webpack_public_path__ + "media/images/restrictions-fill-topbar-62843b0b277a7efc41deabaa5635ee07.svg";